import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"benefit-line-item-container full-width d-flex justify-start align-center",class:{ 'disabled-benefit': _vm.disabledBenefit }},[(_vm.icon)?_c(VIcon,{staticClass:"benefit-line-item-icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('div',{staticClass:"d-flex flex-wrap",staticStyle:{"line-height":"14px"}},[_c('div',{staticClass:"benefit-line-item-label"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }